import { render, staticRenderFns } from "./offline-popup.vue?vue&type=template&id=6be4064c&scoped=true&"
import script from "./offline-popup.vue?vue&type=script&lang=js&"
export * from "./offline-popup.vue?vue&type=script&lang=js&"
import style0 from "./offline-popup.vue?vue&type=style&index=0&id=6be4064c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6be4064c",
  null
  
)

export default component.exports